import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SelectedItemsBar } from '@common/components';
import {
  DeleteIcon,
  EnableIcon,
  DisableIcon,
} from '@common/components/icons';

function SelectedScheduledReportsBar({
  numberOfSelected,
  onDeselectAll,
  onEnable,
  onDisable,
  onDelete,
}) {
  const { t } = useTranslation();

  const actions = [
    {
      key: 'enable',
      icon: EnableIcon,
      text: t('common.enable'),
      onClick: onEnable,
    },
    {
      key: 'disable',
      icon: DisableIcon,
      text: t('common.disable'),
      onClick: onDisable,
    },
    {
      key: 'delete',
      icon: DeleteIcon,
      text: t('common.delete'),
      onClick: onDelete,
    },
  ];

  return (
    <SelectedItemsBar
      numberOfSelectedItems={numberOfSelected}
      itemLabel={
        numberOfSelected === 1
          ? t('scheduledReports.singular')
          : t('scheduledReports.plural')
      }
      onDeselectAll={onDeselectAll}
      actions={actions}
    />
  );
}

SelectedScheduledReportsBar.propTypes = {
  numberOfSelected: PropTypes.number.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
  onEnable: PropTypes.func.isRequired,
  onDisable: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default SelectedScheduledReportsBar;


